import { CellCoordsObj, CellRangeObj, CellSelection } from '../../../../../common/table/TableTypes';
import { getMaxCellSelection, getMinCellSelection } from './tableSelectionGeometryUtils';
import { getCellSelectionFromRange } from './tableSelectionRangeUtils';

type ForEachCellInSelectionArgs = {
    cellSelection: CellSelection;
    callback: (cell: CellCoordsObj) => void;
};

type ForEachCellInRangeArgs = {
    cellRange: CellRangeObj;
    callback: (cell: CellCoordsObj) => void;
};

/**
 * Iterates each cell inside a rectangular selection, inclusive of the provided bounds.
 */
export const forEachCellInSelection = ({ cellSelection, callback }: ForEachCellInSelectionArgs): void => {
    const { row: startRow, col: startCol } = getMinCellSelection(cellSelection);
    const { row: endRow, col: endCol } = getMaxCellSelection(cellSelection);

    for (let row = startRow; row <= endRow; row++) {
        for (let col = startCol; col <= endCol; col++) {
            callback({ row, col });
        }
    }
};

/**
 * Iterates each cell inside a rectangular range, inclusive of the provided bounds.
 */
export const forEachCellInRange = ({ cellRange, callback }: ForEachCellInRangeArgs): void =>
    forEachCellInSelection({
        cellSelection: getCellSelectionFromRange(cellRange),
        callback,
    });
